import React from "react";
import { UserProp } from "@components/common/ddr/ddrTypes";
import { Loader2 } from "lucide-react";
import NoData from "../NoDataLabel";
import SiloImage from "@components/common/ddr/SiloImage";
import ServiceDataList from "./ServiceDataList";

interface SourcesProps {
  userDetails: UserProp;
  loading?: boolean;
  account?: string;
  is_external?: boolean;
}

interface SourceItem {
  source: string;
  service_list: string[];
}

const Services: React.FC<SourcesProps> = ({
  userDetails = {} as UserProp,
  loading: userDataLoading = false,
  account = "",
  is_external = false,
}) => {
  const [sourceList, setSourceList] = React.useState<SourceItem[]>([]);
  const [selectedService, setSelectedService] = React.useState<any>({
    source_type: "",
    service: "",
    open: false,
  });

  React.useEffect(() => {
    const _sourceList: any = [];
    const dataKeys = [
      "files",
      "emails",
      "database",
      "conversations",
      "generics",
    ] as const;
    if (userDetails) {
      dataKeys.forEach((key) => {
        const _sourceData = (userDetails as Record<string, any>)?.[key]
          ?.source_list;
        if (Array.isArray(_sourceData) && _sourceData.length > 0) {
          _sourceList.push({
            source: key,
            service_list: _sourceData,
          });
        }
      });
      setSourceList(_sourceList);
    }
  }, [userDetails]);

  const onClickHandler = (service: string, source: string) => {
    setSelectedService({
      source_type: source,
      service: service,
      open: true,
    });
  };

  return (
    <>
      {selectedService.open && (
        <ServiceDataList
          source_type={selectedService.source_type}
          service={selectedService.service}
          account={account}
          is_external={is_external}
          open={selectedService.open}
          onClose={(e: boolean) =>
            setSelectedService({ ...selectedService, open: e })
          }
        />
      )}

      <div className="p-2 [&>ul>li]:text-sm [&>ul>li]:font-bold [&>ul>li]:text-secondary-foreground flex gap-2 ">
        {userDataLoading ? (
          <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
            <Loader2 size={24} className="animate-spin" />
          </div>
        ) : sourceList.length == 0 ? (
          <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
            <NoData />
          </div>
        ) : (
          sourceList.map((data: SourceItem) =>
            data.service_list.map((item: string, index: number) => (
              <div
                key={`${data.source}-${item}-${index}`}
                className="p-1 flex flex-col items-center"
                onClick={() => onClickHandler(item, data.source)}
              >
                <SiloImage
                  type={item}
                  className="h-12 p-2 shadow-xl rounded-md mb-2"
                />
                <span className="text-xs font-bold capitalize">
                  {item.split("_").join(" ")}
                </span>
              </div>
            )),
          )
        )}
      </div>
    </>
  );
};

export default Services;
